import { stage, trackWithDefaultStage } from "@flights/et-universal";
import { isOfMetaOrigin, isOfPPCOrigin } from "../utils/marketing-url-params.js";
import usePointOfSale from "./usePointOfSale.js";
import useUserAgent from "./useUserAgent.js";
import useRouteName from "./useRouteName.js";
export const useSpringDeal = () => {
    const pointOfSale = usePointOfSale();
    const { isMobile } = useUserAgent();
    const routeName = useRouteName();
    const isSpringDealEligible = pointOfSale === "us" && !isOfMetaOrigin() && !isOfPPCOrigin();
    const isSpringDealExp = isSpringDealEligible && !!trackWithDefaultStage("flights_web_cat_spring_deal_2026", 1);
    if (isSpringDealEligible) {
        stage("flights_web_cat_spring_deal_2026", isMobile ? 3 : 2);
        if (routeName === "fly-anywhere") {
            stage("flights_web_cat_spring_deal_2026", 4);
        }
    }
    return { isSpringDealEligible, isSpringDealExp };
};
